import { generateId } from '@freelancer/datastore/testing';
import {
  VerificationFile,
  VerificationFileSource,
  VerificationProofType,
} from './verification-files.model';

export interface GenerateVerificationFilesOptions {
  readonly verificationRequestId: number;
}

export function generateVerificationFilesObject({
  verificationRequestId,
}: GenerateVerificationFilesOptions): readonly VerificationFile[] {
  return [
    {
      id: generateId(),
      fileId: generateId(),
      verificationRequestId,
      name: 'test_file_name_front.png',
      proofType: VerificationProofType.TYPE_PROOF_ID,
      source: VerificationFileSource.DESKTOP_FILE,
      date: Date.now(),
    },
    {
      id: generateId(),
      fileId: generateId(),
      verificationRequestId,
      name: 'test_file_name_back.png',
      proofType: VerificationProofType.TYPE_PROOF_ID,
      source: VerificationFileSource.DESKTOP_FILE,
      date: Date.now(),
    },
    {
      id: generateId(),
      fileId: generateId(),
      verificationRequestId,
      name: 'test_address_file_name.png',
      proofType: VerificationProofType.TYPE_PROOF_ADDR,
      source: VerificationFileSource.DESKTOP_FILE,
      date: Date.now(),
    },
    {
      id: generateId(),
      fileId: generateId(),
      verificationRequestId,
      name: 'test_keycode_file_name.png',
      proofType: VerificationProofType.TYPE_PROOF_KEYCODE,
      source: VerificationFileSource.DESKTOP_FILE,
      date: Date.now(),
    },
  ];
}
